/* This example requires Tailwind CSS v2.0+ */
import plumbingImage from '../../../images/plumbing.jpg'
export default function Example() {
    return (
      <div className="relative bg-indigo-800">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover"
            src={plumbingImage}
            alt=""
          />
          <div className="absolute inset-0 bg-black opacity-75 mix-blend-multiply" aria-hidden="true" />
        </div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">Dépannage plomberie </h1>
          <p className="mt-6 text-xl text-indigo-100 max-w-3xl">
              Besoin d'une urgence, ou d’un dépannage plomberie, nos plombier sont spécialiser dans le domaine de l’urgence et dépannage plomberie.<br/><br/>
              Nous sommes disponibles 24/24 7J7 possibilité d’intervention en 30 minutes, rendez-vous possible tous les jours.<br/><br/>
              Pour tous renseignement n’hésitez pas à nous contacter au <a href="tel:0032470178102" className='inline-block animate-beating text-blue-500'>0470/17.81.02</a>
          </p>
        </div>
      </div>
    )
  }